import { ReactComponent as SvgDownload } from '@img/icons/download.svg';
import React from 'react';
import S from './DownloadButton.styles';
const DownloadButton = ({ className, format, size, target, text, themeOption = 'brown', url, }) => {
    return (React.createElement(S.Button, { className: className, href: url, target: target, "data-theme": themeOption },
        React.createElement(S.Icon, { as: SvgDownload }),
        React.createElement(S.Content, null,
            React.createElement(S.Text, null, text),
            React.createElement(S.Meta, null,
                React.createElement(S.Format, null, format),
                React.createElement(S.Size, null, size)))));
};
export default DownloadButton;
